/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FC, PropsWithChildren } from 'react'
import Animated, { LinearTransition } from 'react-native-reanimated'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { styled, useTheme } from 'styled-components/native'

import { SnackBar } from 'ui/designSystem/Snackbar/SnackBar'
import { useSnackbarProps } from 'ui/designSystem/Snackbar/snackBar.store'

const DESKTOP_BOTTOM_OFFSET = 72

export const SnackBarWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { isDesktopViewport } = useTheme()
  const snackbarsProps = useSnackbarProps()
  const { top } = useSafeAreaInsets()
  const hasSnackbar = snackbarsProps.length > 0

  return (
    <React.Fragment>
      {hasSnackbar ? (
        <Container top={top} pointerEvents="box-none" accessibilityViewIsModal>
          {snackbarsProps.map(
            (
              {
                onClose,
                label,
                animationDuration,
                type,
                id,
                accessibilityLabel,
                accessibilityHint,
                accessibilityActions,
                onAccessibilityTap,
                onAccessibilityAction,
              },
              index
            ) => (
              <Animated.View
                pointerEvents="box-none"
                accessible
                accessibilityRole="alert"
                accessibilityLiveRegion="assertive"
                accessibilityLabel={accessibilityLabel}
                accessibilityHint={accessibilityHint}
                accessibilityActions={accessibilityActions}
                onAccessibilityTap={onAccessibilityTap}
                onAccessibilityAction={onAccessibilityAction}
                importantForAccessibility="yes"
                style={{ zIndex: 1000 + index }}
                key={id}
                layout={LinearTransition.duration(500).springify()}>
                <SnackBar
                  variant={isDesktopViewport ? 'large' : 'default'}
                  id={id}
                  onClose={onClose}
                  label={label}
                  animationDuration={animationDuration}
                  type={type}
                />
              </Animated.View>
            )
          )}
        </Container>
      ) : null}
      {children}
    </React.Fragment>
  )
}

const Container = styled.View<{ top: number }>(({ theme, top }) => ({
  top: theme.isDesktopViewport ? undefined : top,
  bottom: theme.isDesktopViewport ? DESKTOP_BOTTOM_OFFSET : undefined,
  left: 0,
  right: 0,
  position: 'absolute',
  zIndex: 1000,
}))
